export default __webpack_public_path__ + "static/us-consumer-product-faq-bg-med-f856eff45dbc53826bb3644af9b20cd4.jpg";